import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function ChangePassword() {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const [t] = useTranslation("global");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error(t("changePassword.errors.notMatch"));
      return;
    }

    if (newPassword.length < 6) {
      toast.error(t("changePassword.errors.tooShort"));
      return;
    }

    const userData = JSON.parse(localStorage.getItem("user"));
    if (!userData || !userData.data) {
      toast.error(t("changePassword.errors.noUser"));
      return;
    }

    const requestData = {
      email: userData.data.user.email,
      otp: userData.data.otp,
      password: newPassword,
      password_confirmation: confirmPassword
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestData),
      });

      const result = await response.json();

      if (result.code === 200) {
        toast.success(t("changePassword.messages.success"), {
          autoClose: 2000,
          onClose: () => {
            localStorage.setItem("otpAllowed", "true");
            navigate("/login");
          }
        });
        localStorage.removeItem("user");
      } else {
        toast.error(result.message || t("changePassword.errors.failed"));
      }
    } catch (error) {
      toast.error(t("changePassword.errors.server"));
    }
  };

  return (
    <section style={{ backgroundColor: "#193C6E", minHeight: "100vh" }}>
      <ToastContainer />

      <div className="container h-100">
        <div className="row d-flex justify-content-center align-items-center min-vh-100">
          <div className="col-lg-6 col-md-12">
            <img
              src="assets/imgs/Layer 4.png"
              width="100%"
              alt="Change Password Illustration"
            />
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="card-singin p-4 shadow rounded-4">
              <div>
                <img
                  src="assets/imgs/تميز copy 1.svg"
                  alt="Taamayaz Logo"
                  className="mb-3"
                />
                <h3 className="second-color mt-3">{t("changePassword.title")}</h3>
                <p className="text-muted m-0 p-0">
                  {t("changePassword.description")}
                </p>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row mt-3">
                  <div className="col-md-12 mb-2">
                    <label className="mb-2 d-block" htmlFor="password">
                      {t("changePassword.newPasswordLabel")}
                    </label>
                    <div className="position-relative">
                      <input
                        type={showNewPassword ? "text" : "password"}
                        id="password"
                        className="form-control mb-2"
                        placeholder={t("changePassword.newPasswordPlaceholder")}
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                      <span
                        onClick={() => setShowNewPassword(!showNewPassword)}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#999",
                        }}
                        className="eye-icons"
                      >
                        {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-12 mb-2">
                    <label className="mb-2 d-block" htmlFor="confirm-password">
                      {t("changePassword.confirmPasswordLabel")}
                    </label>
                    <div className="position-relative">
                      <input
                        type={showConfirmPassword ? "text" : "password"}
                        id="confirm-password"
                        className="form-control mb-2"
                        placeholder={t("changePassword.confirmPasswordPlaceholder")}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                      <span
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        style={{
                          position: "absolute",
                          right: "10px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#999",
                        }}
                        className={'eye-icons'}
                      >
                        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                      </span>
                    </div>
                  </div>
                </div>

                <button
                  type="submit"
                  style={{ backgroundColor: "#352E64", color: "#fff" }}
                  className="btn w-100 py-2 my-3"
                >
                  {t("changePassword.submitButton")}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
